import React from "react";
import { AddSponsorContainer } from "../../../containers";

const AddSponsor = (props) => {
  return <AddSponsorContainer {...props} />;
};

export default AddSponsor;
